import authSelector from 'modules/Auth/selectors'
import ViewCollegeDetails from 'modules/Roles/Partials/ViewCollegeDetails'
import rolesSelectors from 'modules/Roles/selectors'
import { connect } from 'react-redux'

import { resumeBulkDownload } from 'modules/Drives/actions'
import {
  createDrive,
  getAppliedCandidateList,
  getAppliedCollegesList,
  getCandidateDetails,
  getCities,
  getDegreesBasedOnRoles,
  getDriveCreatedCandidates,
  getDriveCreatedCandidatesPreview,
  getDriveNotCreatedCandidates,
  getInstituteCampusDetails,
  getInstitutesList,
  getListOfDegree,
  getPromotion,
  getRoleDraftData,
  getSingleRoleData,
  setInstitutesList,
} from 'modules/Roles/actions'
const mapStateToProps = state => ({
  instituteCampusDetails: rolesSelectors.getInstituteCampusDetails(state),
  appliedCollegesList: rolesSelectors.getAppliedCollegesList(state),
  listOfDegree: rolesSelectors.getListOfDegree(state),
  singleRoleData: rolesSelectors.getSingleRoleData(state),
  listOfCities: rolesSelectors.getListOfCities(state),
  institutesList: rolesSelectors.getInstitutesList(state),
  candidateDetails: rolesSelectors.getCandidateDetails(state),
  promotionData: rolesSelectors.getPromotion(state),
  roleBasedDegreeList: rolesSelectors?.getDegreeRolesList(state),

  corporateId: authSelector.getCorporateId(state),

  DriveNotCreatedCandidates: rolesSelectors.getDriveNotCreatedCandidates(state),
  DriveCreatedCandidates: rolesSelectors.getDriveCreatedCandidates(state),
  DriveCreatedCandidatesPreview:
    rolesSelectors.getDriveCreatedCandidatesPreview(state),
  draftData: rolesSelectors.getRoleDraftData(state),
})

const mapDispatchToProps = {
  getAppliedCollegesList,
  getAppliedCandidateList,
  getListOfDegree,
  getSingleRoleData,
  getCities,
  createDrive,
  getInstituteCampusDetails,
  getInstitutesList,
  setInstitutesList,
  getCandidateDetails,
  getPromotion,
  getDegreesBasedOnRoles,
  getDriveCreatedCandidates,
  getDriveNotCreatedCandidates,
  getDriveCreatedCandidatesPreview,
  getRoleDraftData,
  resumeBulkDownload,
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewCollegeDetails)
